import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

// Hilfsfunktion: Wandelt normale YouTube Links in Embed-Links um
function getEmbedUrl(url) {
  if (!url) return '';
  if (url.includes('youtube.com/watch?v=')) {
    return url.replace('watch?v=', 'embed/');
  }
  if (url.includes('youtu.be/')) {
    return url.replace('youtu.be/', 'youtube.com/embed/');
  }
  return url;
}

export function VideoRender({ node, isLiveMode }) {
  const content = node.content || {};
  const url = content.url || 'https://www.youtube.com/embed/dQw4w9WgXcQ';
  const embedUrl = getEmbedUrl(url);
  const aspectRatio = content.aspectRatio || '16 / 9';
  const radius = content.radius || '8px';

  return (
    <div style={{ 
      position: 'relative', 
      width: '100%', 
      aspectRatio: aspectRatio, 
      borderRadius: radius,
      overflow: 'hidden',
      pointerEvents: !isLiveMode ? 'none' : 'auto' // Im Editor Klicks blockieren, damit man es Draggen kann
    }}>
      {embedUrl ? (
        <iframe 
          src={embedUrl} 
          title="Video Player" 
          frameBorder="0" 
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
          allowFullScreen
          style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        />
      ) : (
        <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(255,255,255,0.05)' }}>
          Ungültige Video-URL
        </div>
      )}
    </div>
  );
}

registry.register('Video', {
  label: 'Video',
  icon: '▶️', 
  category: 'media',
  component: VideoRender,
  
  defaultProps: {
    content: {
      url: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
      aspectRatio: '16 / 9',
      radius: '8px'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Video Quelle',
          fields: [
            { name: 'content.url', label: 'YouTube URL', type: 'text' }
          ]
        },
        {
          title: 'Darstellung',
          fields: [
            { name: 'content.aspectRatio', label: 'Seitenverhältnis', type: 'select', options: ['16 / 9', '4 / 3', '1 / 1', '9 / 16'] },
            { name: 'content.radius', label: 'Abgerundete Ecken', type: 'text' }
          ]
        }
      ]
    }
  ]
});
